// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"150d5589","668":"607bcb46","762":"6459afda"}[chunkId] + ".js";
};